module.exports = __webpack_public_path__ + "static/media/4a8f0a9d-2c2e-47b0-91b0-8e698e3ab04e.12dfa322.JPG";